import React from "react";
import Helper from "../Helper";

type CommandCenterIframeProps = {
    iframeConfig: any;
};

const CommandCenterIframe: React.FC<CommandCenterIframeProps> = ({ iframeConfig }) => {
    // Using iframe to embed the Jobsite Command UI.

    return (
        <div className="flex flex-col h-full w-full">
            <div className="w-full h-full ">
                {Helper.isHTMLBlock(iframeConfig.url) ? (
                    <div
                        className="w-full h-full rounded-lg leading-loose"
                        dangerouslySetInnerHTML={{ __html: iframeConfig.url }}
                    ></div>
                ) : (
                    <iframe src={iframeConfig.url} className="w-full h-full rounded-lg" />
                )}
            </div>
        </div>
    );
};

export default CommandCenterIframe;
